export default __webpack_public_path__ + "static/media/Bilo3-8.02aa5a0f.jpg";